/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Change_Applied_A_To_BInputs */

const en_compare_event_groups_change_applied_a_to_b = /** @type {(inputs: Compare_Event_Groups_Change_Applied_A_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change applied from Group A to Group B`)
};

const fr_compare_event_groups_change_applied_a_to_b = /** @type {(inputs: Compare_Event_Groups_Change_Applied_A_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modification appliquée du groupe A au groupe B`)
};

const de_compare_event_groups_change_applied_a_to_b = /** @type {(inputs: Compare_Event_Groups_Change_Applied_A_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderung von Gruppe A auf Gruppe B angewendet`)
};

const it_compare_event_groups_change_applied_a_to_b = /** @type {(inputs: Compare_Event_Groups_Change_Applied_A_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica applicata dal Gruppo A al Gruppo B`)
};

const ru_compare_event_groups_change_applied_a_to_b = /** @type {(inputs: Compare_Event_Groups_Change_Applied_A_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение внесено из группы А в группу В.`)
};

const es_compare_event_groups_change_applied_a_to_b = /** @type {(inputs: Compare_Event_Groups_Change_Applied_A_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio aplicado del Grupo A al Grupo B`)
};

const zh_cn2_compare_event_groups_change_applied_a_to_b = /** @type {(inputs: Compare_Event_Groups_Change_Applied_A_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从A组变更至B组`)
};

const ja_compare_event_groups_change_applied_a_to_b = /** @type {(inputs: Compare_Event_Groups_Change_Applied_A_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループAからグループBへの変更`)
};

const hi_compare_event_groups_change_applied_a_to_b = /** @type {(inputs: Compare_Event_Groups_Change_Applied_A_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह A से समूह B में परिवर्तन लागू किया गया`)
};

const pt_pt2_compare_event_groups_change_applied_a_to_b = /** @type {(inputs: Compare_Event_Groups_Change_Applied_A_To_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alteração aplicada do Grupo A para o Grupo B`)
};

/**
* | output |
* | --- |
* | "Change applied from Group A to Group B" |
*
* @param {Compare_Event_Groups_Change_Applied_A_To_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_change_applied_a_to_b = /** @type {((inputs?: Compare_Event_Groups_Change_Applied_A_To_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Change_Applied_A_To_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_change_applied_a_to_b(inputs)
	if (locale === "de") return de_compare_event_groups_change_applied_a_to_b(inputs)
	if (locale === "it") return it_compare_event_groups_change_applied_a_to_b(inputs)
	if (locale === "ru") return ru_compare_event_groups_change_applied_a_to_b(inputs)
	if (locale === "es") return es_compare_event_groups_change_applied_a_to_b(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_change_applied_a_to_b(inputs)
	if (locale === "ja") return ja_compare_event_groups_change_applied_a_to_b(inputs)
	if (locale === "hi") return hi_compare_event_groups_change_applied_a_to_b(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_change_applied_a_to_b(inputs)
	return en_compare_event_groups_change_applied_a_to_b(inputs)
});